module.exports = __webpack_public_path__ + "static/media/ConferenceYear2016.49ebb257.png";